exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3DLZN{margin-top:16px}._11epP{margin-left:16px;margin-right:16px}.VjAIa{margin-right:0;text-align:justify}._6QrZA{width:100%;color:grey}._6QrZA:hover{cursor:pointer}._2sFxB{background-color:#d3d3d3}._2Yasu{font-weight:700}nameWidth{width:75%}priceWidth{margin-left:8px}", ""]);

// exports
exports.locals = {
	"top": "_3DLZN",
	"margin": "_11epP",
	"orderProcessed": "VjAIa",
	"myProductsButton": "_6QrZA",
	"grey": "_2sFxB",
	"bold": "_2Yasu"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"module":true,"modules":true,"localIdentName":"[hash:base64:5]"}!../node_modules/sass-loader/lib/loader.js?{"outputStyle":"collapsed","sourceMap":true,"includePaths":["/Users/markromero/Code/frn-platform-frontend/src"]}!./routes/Checkout/components/OrderConfirmation/styles.scss
// module id = 1131
// module chunks = 0